import { useEffect } from "react";
import * as amplitude from "@amplitude/analytics-browser";
import { useChannelIOApi } from "react-channel-plugin";
import { User } from "common/models/types";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { log, LogLevel } from "utils/LogUtil";

let amplitudeInstance: any;
const env = process.env.REACT_APP_ENV ? `${process.env.REACT_APP_ENV}` : "";

// [2025-01-27] 결정사항: Amplitude instance를 일관되게 관리하기 위해 초기화 함수를 분리함
function initializeAmplitude() {
  if (!amplitudeInstance) {
    amplitudeInstance = amplitude.createInstance();
    const sessionReplayTracking = sessionReplayPlugin();
    amplitudeInstance.add(sessionReplayTracking);
    amplitudeInstance.init("a7872efdc0dc20d799f34d2253423341", {
      defaultTracking: {
        sessions: true,
      },
      autocapture: {
        attribution: true, // UTM, Referrer, Click ID 자동 추적 활성화
        pageViews: true,
        sessions: false,
      },
    });
  }
  return amplitudeInstance;
}

export function setUserProperty(user: User) {
  log(LogLevel.VERBOSE, "AmplitudeUtil: setUserProperty", user);
  const { id: userId, name: userName, email, roles } = user;

  const instance = initializeAmplitude();

  // User ID 설정
  instance.setUserId(`${userId}`);

  // User Properties 설정 - 중복 제거 및 올바른 API 사용
  const identifyEvent = new amplitude.Identify();
  identifyEvent.set("userName", userName);
  identifyEvent.set("email", email);
  identifyEvent.set("roles", roles.join(","));

  // [2025-01-27] 결정사항: 올바른 instance.identify() 메서드 사용
  instance.identify(identifyEvent);
}

export function eventLog(name: string, eventProperties?: any) {
  log(LogLevel.VERBOSE, "AmplitudeUtil: eventLog", name, eventProperties);

  const instance = initializeAmplitude();
  instance.track(`PHAI_${name}`, { ...eventProperties, env });
}
